import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';

import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import LoadingAlert from '../../Alerts/LoadingAlert';
import ErrorAlert from '../../Alerts/ErrorAlert';
 import './ModalDetaillsEvent.css';
const ModalDetaillsEvent = ({ eventDataState }) => {
    const [show, setShow] = useState(false)


    return (
        <>
            {/* <div className="event-pill d-flex align-items-center px-3 py-1 rounded-pill shadow-sm" style={{ background: '#FFF7E6', border: '1px solid #f59e0b', color: '#b45309', fontWeight: 'bold', fontSize: '1rem', cursor: 'pointer', transition: 'box-shadow 0.2s' }} onClick={()=> setShow(true)}>
                <span className="me-2" style={{ width: 10, height: 10, background: '#f59e0b', borderRadius: '50%', display: 'inline-block' }}></span>
                <span style={{ fontWeight: 600 }}>Evento: </span>
            </div> */}



            <div className="sp-eventbar" role="status" onClick={() => setShow(true)}>
                <span className="sp-eventbar__dot" aria-hidden="true" />
                <i className="uil uil-calendar-alt sp-eventbar__ic"></i>
                <span className="sp-eventbar__tx">
                    Evento activo: <strong>{eventDataState.name}</strong>
                </span>
            </div>


            <Modal
                show={show}
                onHide={() => setShow(false)}
                centered
                dialogClassName="sp-ev-dialog"
                contentClassName="sp-ev-content"
            >
                <Modal.Body className="sp-ev">

                    {/* Header */}
                    <div className="sp-ev__head">
                        <div className="sp-ev__badge"><i className="uil uil-calendar-alt"></i></div>
                        <h3 className="sp-ev__title">Detalle del evento</h3>
                        <button className="sp-ev__x" type="button" aria-label="Cerrar" onClick={() => setShow(false)}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                        </button>
                    </div>

                    {/* Cuerpo */}
                    <div className="sp-ev__body">
                        <div className="sp-ev__card">
                            <h4 className="sp-ev__name">{eventDataState.name}</h4>
                            <p className="sp-ev__desc">{eventDataState.description}</p>

                            <div className="sp-ev__meta">
                                <div className="sp-ev__metaitem">
                                    <i className="uil uil-check-circle" style={{ color: eventDataState.state === 1 ? 'var(--green,#0EA35B)' : 'var(--red,#E11D2E)' }}></i>
                                    <span>{eventDataState.state === 1 ? 'Activo' : 'Inactivo'}</span>
                                </div>
                                <div className="sp-ev__metaitem">
                                    <i className="uil uil-calendar-alt sp-ev__metaic"></i>
                                    <span>
                                        {eventDataState.dates && eventDataState.dates.length > 0
                                            ? `${new Date(eventDataState.dates[0].initialDate).toLocaleDateString()} - ${new Date(eventDataState.dates[0].maxDate).toLocaleDateString()}`
                                            : 'Sin fecha'}
                                    </span>
                                </div>
                            </div>

                            {eventDataState.dates && eventDataState.dates.length > 0 && (
                                <div className="sp-ev__datedesc">
                                    <span className="sp-ev__datebadge">{eventDataState.dates[0].description}</span>
                                </div>
                            )}

                            <div className="sp-ev__ids">
                                <span className="sp-ev__idbadge">ID evento: {eventDataState.id}</span>
                                <span className="sp-ev__idbadge">ID fecha evento: {eventDataState.event_date_id}</span>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalDetaillsEvent